module.exports = __webpack_public_path__ + "assets/img/c7f9-ye.svg";